<mat-card>
    <mat-card-title class="font-weight-bold caption-color"><b> Business Details </b></mat-card-title>
    <mat-divider></mat-divider>
    
    <mat-card-content class="pt-2">

<div class="row" *ngFor="let BillingItem of ConsBillingDetails; let i = index;">
    <div class="col-sm-12">

        <table class="table">
            <thead>
                <tr>
                    <th> {{BillingItem.Heading}}</th>
                    <th class="text-right" *ngFor="let item of BillingItem.Data; let j = index;">{{item.FM }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td> {{BillingItem.TargetHeading}}</td>
                    <td class="text-right" *ngFor="let item of BillingItem.Data; let j = index;">{{item.Target | number : '1.2-2'}}</td>
                </tr>
                <tr>
                    <td> {{BillingItem.BillingHeading}}</td>
                    <td class="text-right" *ngFor="let item of BillingItem.Data; let j = index;">{{item.Billing | number : '1.2-2'}}</td>
                </tr>

                <tr>
                    <td> {{BillingItem.AchievementHeading}}</td>
                    <td class="text-right" *ngFor="let item of BillingItem.Data; let j = index;">{{item.Achievments }}%</td>
                </tr>
                


            </tbody>
        </table>

    </div>
</div>

    </mat-card-content>
    </mat-card>
